//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
import "../no/SelectBody.js";
import "../Tooling/Tooling.IntermediateStageBuilder.js";
import "../no/SelectObject.js";
let d=[[[0,"CreateCopyPart",1,0],[0,"DecimalPlace",1,0],[1,"DrawPartSelect",0,"SelectBody",0],[0,"DrawRatio",1,0],[0,"FirstDrawRatio",1,0],[0,"FlangeDelta",1,0],[0,"IntermediateNamingRule",1,0],[0,"IntermediateRename",1,0],[1,"IntermediateStageBuilder",0,"Tooling.IntermediateStageBuilder",0],[0,"MaterialName",1,0],[0,"Thickness",1,0],[0,"TopPartName",1,0]],[[[],"ValidateSelectedPart",{},0,0],[[],"UpdateFlangeAllowanceEvent",{},0,0],[[],"UpdateMaterialPamrs",{},0,0],[["stageIndex","dataType","value"],"SetIntermediateStagesData",{},3,0],[["stageIndex","dataType"],"GetIntermediateStagesData",{R_:{value:''}},2,0],[[],"SynchroIntermediateStageData",{},0,0],[[],"ChangeFirstDrawRatioEvent",{},0,0],[["bodyNum","bodies"],"CreateStageBodiesInWorkPart",{},0,0]],[]];
SPLM.Tooling.DrawPartAutoStageBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DrawPartAutoStageBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DrawPartAutoStageBuilder.RoundDrawDataType = Object.freeze({
    "Diameter" : "Diameter", "DrawRatio" : "DrawRatio", "DieRadius" : "DieRadius", "PunchRadius" : "PunchRadius", "DrawHeight" : "DrawHeight"});

export default SPLM;